module.exports = __webpack_public_path__ + "img/lab-4.281d077d.png";